import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../api/client';

export interface GamesState {
  games: any[];
  promotions: any[];
  loading: boolean;
  error: string | null;
}

const initialState: GamesState = {
  games: [],
  promotions: [],
  loading: false,
  error: null,
};

export const fetchGamesAndPromos = createAsyncThunk(
  'games/fetchGamesAndPromos',
  async (_, { rejectWithValue }) => {
    try {
      const [gamesRes, promosRes] = await Promise.all([
        api.games.list(),
        api.promotions.list(),
      ]);
      return {
        games: gamesRes.success ? (gamesRes.data || []) : [],
        promotions: promosRes.success ? (promosRes.data || []) : [],
      };
    } catch (err: any) {
      return rejectWithValue(err.message || 'Failed to fetch games and promotions');
    }
  }
);

const gamesSlice = createSlice({
  name: 'games',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGamesAndPromos.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGamesAndPromos.fulfilled, (state, action) => {
        state.loading = false;
        state.games = action.payload.games;
        state.promotions = action.payload.promotions;
      })
      .addCase(fetchGamesAndPromos.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default gamesSlice.reducer;
